import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout/index'
import { getToken } from "@/utils/auth"
Vue.use(Router)
// import nprogress from 'nprogress'
// import 'nprogress/nprogress.css'

 const constantRouter = [
    { 
        path: '/login',
        name:'login',
        component:()=>import('@/views/login/login'),
        meta:{}
    },
    { 
        path:'/',
        name:'layout',
        component:layout,
        redirect: '/admin',
        meta:{},
        children:[
            {
                path:'admin',
                name:'admin',
                component:()=>import('@/views/layout/admin/index')
            },
            {
                path:'restaurant',
                name:'restaurant',
                component:()=>import('@/views/layout/restaurant/index')
            },
            {
                path:'wineshop',
                name:'wineshop',
                component:()=>import('@/views/layout/wineshop/index')
            },
            {
                path:'wineshop/new',
                name:'wineshop/new',
                component:()=>import('@/views/layout/wineshop/new')
            },
            {
                path:'wineshop/edit',
                name:'wineshop/edit',
                component:()=>import('@/views/layout/wineshop/edit')
            },
            {
                path:'restaurant/new',
                name:'restaurant/new',
                component:()=>import('@/views/layout/restaurant/new')
            },
            {
                path:'restaurant/edit',
                name:'restaurant/edit',
                component:()=>import('@/views/layout/restaurant/edit')
            },
            {
                path:'message/user',
                name:'message/user',
                component:()=>import('@/views/layout/message/userMessage')
            },
            {
                path:'message/admin',
                name:'message/admin',
                component:()=>import('@/views/layout/message/adminMessage')
            },
            {
                path:'system/platform',
                name:'system/platform',
                component:()=>import('@/views/layout/system/platform')
            },
            {
                path:'system/payment',
                name:'system/payment',
                component:()=>import('@/views/layout/system/payment')
            },
            {
                path:'system/banner',
                name:'system/banner',
                component:()=>import('@/views/layout/system/banner')
            },
            {
                path:'shop/list',
                name:'shop/list',
                component:()=>import('@/views/layout/shop/list')
            },
            {
                path:'shop/examine',
                name:'shop/examine',
                component:()=>import('@/views/layout/shop/examine')
            },
            {
                path:'shop/classification',
                name:'shop/classification',
                component:()=>import('@/views/layout/shop/classification')
            },
            {
                path:'shop/addShop',
                name:'shop/addShop',
                component:()=>import('@/views/layout/shop/addShop')
            },
            {
                path:'shop/newClassification',
                name:'shop/newClassification',
                component:()=>import('@/views/layout/shop/newClassification')
            },
            {
                path:'shop/editClassification',
                name:'shop/editClassification',
                component:()=>import('@/views/layout/shop/editClassification')
            },
            {
                path:'shop/editShop',
                name:'shop/editShop',
                component:()=>import('@/views/layout/shop/editShop')
            },
            {
                path:'goods/list',
                name:'goods/list',
                component:()=>import('@/views/layout/goods/list')
            },
            {
                path:'goods/goodexamine',
                name:'goods/goodexamine',
                component:()=>import('@/views/layout/goods/goodexamine')
            },
            {
                path:'goods/editCategory',
                name:'goods/editCategory',
                component:()=>import('@/views/layout/goods/editCategory')
            },
            {
                path:'goods/newLabel',
                name:'goods/newLabel',
                component:()=>import('@/views/layout/goods/newLabel')
            },
            {
                path:'goods/editLabel',
                name:'goods/editLabel',
                component:()=>import('@/views/layout/goods/editLabel')
            },
            {
                path:'goods/goodsLabel',
                name:'goods/goodsLabel',
                component:()=>import('@/views/layout/goods/goodsLabel')
            },
            {
                path:'goods/goodsCategory',
                name:'goods/goodsCategory',
                component:()=>import('@/views/layout/goods/goodsCategory')
            },
            {
                path:'goods/product',
                name:'product',
                component:()=>import('@/views/layout/goods/product')
            },
            {
                path:'goods/edit',
                name:'edit',
                component:()=>import('@/views/layout/goods/edit')
            },
            {
                path:'goods/recyclingStation',
                name:'goods/recyclingStation',
                component:()=>import('@/views/layout/goods/recyclingStation')
            },
            {
                path:'shopOrder/orderList',
                name:'shopOrder/orderList',
                component:()=>import('@/views/layout/shopOrder/orderList')
            },
            {
                path:'shopOrder/refundApplication',
                name:'shopOrder/refundApplication',
                component:()=>import('@/views/layout/shopOrder/refundApplication')
            },
            {
                path:'shopOrder/express',
                name:'shopOrder/express',
                component:()=>import('@/views/layout/shopOrder/express')
            },
            {
                path:'shopOrder/refundRecord',
                name:'shopOrder/refundRecord',
                component:()=>import('@/views/layout/shopOrder/refundRecord')
            },
            {
                path:'statistics/goods_stat',
                name:'statistics/goods_stat',
                component:()=>import('@/views/layout/statistics/goods_stat')
            },
            {
                path:'statistics/sales_stat',
                name:'statistics/sales_stat',
                component:()=>import('@/views/layout/statistics/sales_stat')
            },
            {
                path:'statistics/revenue_stat',
                name:'statistics/revenue_stat',
                component:()=>import('@/views/layout/statistics/revenue_stat')
            },
            {
                path:'system/bannerEdit',
                name:'system/bannerEdit',
                component:()=>import('@/views/layout/system/bannerEdit')
            },
            {
                path:'system/list',
                name:'system/list',
                component:()=>import('@/views/layout/system/list')
            },
            {
                path:'system/addBanner',
                name:'system/addBanner',
                component:()=>import('@/views/layout/system/addBanner')
            },
            {
                path:'record/login',
                name:'/record/login',
                component:()=>import('@/views/layout/record/login')
            },
            {
                path:'record/operate',
                name:'/record/operate',
                component:()=>import('@/views/layout/record/operate')
            },
        ]
    }
   
]
const createRouter = () => {
    return  new Router({
        scrollBehavior: () => ({ y: 0 }),
        routes: constantRouter,
        mode:'history'
        })
    }
const router = createRouter()
router.beforeEach((to,from,next)=>{
    // nprogress.start()
    if(getToken()){
        if(to.path=='/login'){
            next('/');
        }else{
            next();
        }
    }else{
        if(to.path !=='/login'){
            next('/login');
        }else{
            next();
        }
        
    }
})
// router.afterEach((to,from,next)=>{
//     // nprogress.done()
// })
export default router